import { vectorToArray as H, roundColumnSums as z, sumColumns as V, selectColumns as G, getColumnValues as X, generateColumnsIfMissing as q, groupByAndSum as Q } from "../utils/arrow/helpers.js";
import { CONST as x } from "../utils/constants.js";
import { withGC as p } from "../utils/pyodide/gc.js";
import "../utils/pyodide/pyodideContext.js";
import { seriesToArrow as Z, dataFrameToArrow as K } from "../utils/pyodide/toJs/arrow.js";
import { PyodideObjectAsyncConstructable as ee } from "../utils/pyodideObjectAsyncConstructable.js";
import { yieldToMainThread as c } from "../utils/yieldToMainThread.js";
import { M as te, e as se } from "../index-DyQVTxYk.js";
import { m as ie, a as re } from "../arrow-BHuGfQRn.js";
function u(r) {
  const e = Object.prototype.toString.call(r);
  return r instanceof Date || typeof r == "object" && e === "[object Date]" ? new r.constructor(+r) : typeof r == "number" || e === "[object Number]" || typeof r == "string" || e === "[object String]" ? new Date(r) : /* @__PURE__ */ new Date(NaN);
}
function b(r, e) {
  return r instanceof Date ? new r.constructor(e) : new Date(e);
}
function A(r, e) {
  const t = u(r);
  return isNaN(e) ? b(r, NaN) : (e && t.setDate(t.getDate() + e), t);
}
const ae = 6048e5, ne = 864e5;
function oe(r, e) {
  const t = e?.weekStartsOn, s = u(r), i = s.getDay(), a = (i < t ? 7 : 0) + i - t;
  return s.setDate(s.getDate() - a), s.setHours(0, 0, 0, 0), s;
}
function P(r) {
  return oe(r, { weekStartsOn: 1 });
}
function ce(r) {
  const e = u(r), t = e.getFullYear(), s = b(r, 0);
  s.setFullYear(t + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const i = P(s), a = b(r, 0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  const n = P(a);
  return e.getTime() >= i.getTime() ? t + 1 : e.getTime() >= n.getTime() ? t : t - 1;
}
function F(r) {
  const e = u(r);
  return e.setHours(0, 0, 0, 0), e;
}
function I(r) {
  const e = u(r), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +r - +t;
}
function le(r, e) {
  const t = F(r), s = F(e), i = +t - I(t), a = +s - I(s);
  return Math.round((i - a) / ne);
}
function de(r) {
  const e = ce(r), t = b(r, 0);
  return t.setFullYear(e, 0, 4), t.setHours(0, 0, 0, 0), P(t);
}
function ue(r, e) {
  const t = u(r), s = u(e), i = J(t, s), a = Math.abs(le(t, s));
  t.setDate(t.getDate() - i * a);
  const n = +(J(t, s) === -i), l = i * (a - n);
  return l === 0 ? 0 : l;
}
function J(r, e) {
  const t = r.getFullYear() - e.getFullYear() || r.getMonth() - e.getMonth() || r.getDate() - e.getDate() || r.getHours() - e.getHours() || r.getMinutes() - e.getMinutes() || r.getSeconds() - e.getSeconds() || r.getMilliseconds() - e.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function pe(r) {
  const e = u(r);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function M(r) {
  const e = u(r), t = +P(e) - +de(e);
  return Math.round(t / ae) + 1;
}
function j(r) {
  let t = u(r).getDay();
  return t === 0 && (t = 7), t;
}
function Y(r, e) {
  const t = u(r), s = j(t), i = e - s;
  return A(t, i);
}
var me = /* @__PURE__ */ ((r) => (r.BUDGET = "budget", r.MEDIA_KPI = "mediaKpi", r.TOTAL_KPI = "totalKpi", r))(me || {});
class Pe extends ee {
  constructor(e, t, s) {
    const i = async (a) => await a.runPython(`
            async def load_optimiser(data_source_reader):
                try:
                  from core_optimizer import Optimiser, MegastarOutputReader, InitialData
                  raw_data = data_source_reader.read()
                  initial_optimiser_data = InitialData(*raw_data)
                  return Optimiser(initial_optimiser_data)
                except Exception as ex:
                  print('Failed to load optimiser', ex)
                  raise ex

            load_optimiser
        `)(t.pyObject);
    super(
      e,
      i,
      s.optimiserWheelPath,
      s.duckDbWheelUrl,
      s.jsonConfig,
      s.options,
      s.initPyodide
    ), this.dataSourceReaderService = t;
  }
  dataSourceReaderService;
  get mostRecentYearRowCount() {
    return this._mostRecentYearRowCount;
  }
  set mostRecentYearRowCount(e) {
    this._mostRecentYearRowCount = e;
  }
  get pyOptimiser() {
    return this.pyObject;
  }
  get messageBroker() {
    return this.pyObject.message_broker;
  }
  get investmentStep() {
    return 100;
  }
  cache_megastarOutputReaderService;
  // Cached Python utility functions
  _pyodideUtilsCache = {};
  _toPyDate;
  get reader() {
    return this.cache_megastarOutputReaderService ??= new te(
      void 0,
      this.pyObject.datasource_reader,
      {
        locales: [se],
        pyodide: this.pyodide
      }
    );
  }
  get recentYearSpends() {
    return p(this.pyOptimiser).last_year_spends_detailed_pl.to_pandas().to_json();
  }
  get recentYearMediumTotalSpends() {
    const e = this.pyOptimiser.context.historic_spends.toJs();
    return JSON.stringify(e);
  }
  get naturalDemandIndiceDataFrames() {
    const e = async (t) => p(this.pyOptimiser.get_natural_demand(), async (s) => await Z(this.pyodide, s.at(t)));
    return {
      get Monthly() {
        return e(0);
      },
      get WeeklyByWeekOfMonth() {
        throw new Error("Not implemented");
      },
      get Weekly() {
        return e(1);
      },
      get Daily() {
        return e(2);
      }
    };
  }
  getNaturalDemandData() {
    return this.pyOptimiser.get_natural_demand().toJs();
  }
  get allocation() {
    return this.optimalSpends;
  }
  get medias() {
    return this.pyObject.context.media.toJs();
  }
  getRoiCurvesData() {
    const t = this.getPyodideUtil("generate_yearly_roi_curves")(this.pyObject);
    return JSON.parse(t);
  }
  get diminishing() {
    return p(this.pyObject).get_diminishing().toJs();
  }
  get optimalSpends() {
    const e = p(this.pyObject).optimal_spends.toJs();
    return JSON.stringify(e);
  }
  get lowestLimits() {
    return p(this.pyObject.get_context()).lower_limits.toJs();
  }
  get highestLimits() {
    return p(this.pyObject.get_context()).upper_limits.toJs();
  }
  get lowestBudget() {
    return p(this.pyObject.get_context()).lowest_budget;
  }
  get highestBudget() {
    return p(this.pyObject.get_context()).highest_budget;
  }
  get maxBudget() {
    return this.highestBudget;
  }
  _mostRecentYearRowCount = 0;
  diminishingPoint(e) {
    const t = H(e), s = t.map((i, a) => {
      const n = t[a - 1] || 0;
      return i - n;
    });
    return s.indexOf(Math.max(...s)) * this.investmentStep;
  }
  getPyodideUtil(e) {
    return this._pyodideUtilsCache[e] || (this._pyodideUtilsCache[e] = this.pyodide.runPython(`
        from core_optimizer.optimiser.pyodide_utils import ${e}
        ${e}
      `)), this._pyodideUtilsCache[e];
  }
  getToPyDate() {
    return this._toPyDate || (this._toPyDate = this.pyodide.runPython(`
        from datetime import datetime
        def to_py_datetime(js_date):
            return datetime.fromtimestamp(js_date.valueOf() / 1000)
        to_py_datetime
      `)), this._toPyDate;
  }
  getSpendLimitsFromContext() {
    const e = this.pyOptimiser.get_context(), t = e.lower_limits.toJs(), s = e.upper_limits.toJs(), i = e.media.toJs(), a = {}, n = {};
    return i.forEach((l, m) => {
      a[l] = t[m], n[l] = s[m];
    }), { medias: i, minimumSpends: a, maximumSpends: n };
  }
  normalizeKpisArray(e, t) {
    if (Array.isArray(e))
      return e.map((s) => typeof s == "number" ? s : 0);
    if (typeof e == "object" && e !== null) {
      const s = e, i = Object.keys(s).filter((a) => !isNaN(Number(a))).sort((a, n) => Number(a) - Number(n));
      return i.length === t.length ? i.map((a) => s[a] || 0) : t.map((a) => s[a] || 0);
    }
    return new Array(t.length).fill(0);
  }
  buildOptimal(e, t, s, i, a, n, l, m, h) {
    const y = e.toJs ? e.toJs() : e, d = t.map((g) => y[g] || 0), w = d.reduce((g, k) => g + k, 0), _ = n + l;
    return {
      budget: h === "budget" ? m : w,
      currentKpi: h === "totalKpi" ? _ : n,
      totalKpi: _,
      mediums: t,
      spends: d,
      minimumSpends: s,
      maximumSpends: i,
      kpis: a
    };
  }
  async resetOptimisationRules() {
    this.pyOptimiser.rules.reset_rules();
  }
  async readMessages() {
    const e = this.messageBroker.get_messages_and_clear().toJs();
    return e && e.length > 0 ? e.map((t) => ({
      messageLevel: t.message_level?.toString() || "ERROR",
      message: t.message?.toString() || "",
      timestamp: t.timestamp?.toString() || "",
      code: t.code?.toString() || ""
    })) : [];
  }
  async addOptimisationExactBudgetRule(e, t) {
    await c();
    const s = this.pyOptimiser.get_context();
    this.pyOptimiser.rules.process_rule_addition_request(
      s,
      e,
      "Total budget",
      "is exactly",
      t.toString()
    ), await c();
  }
  async getMediasLimits() {
    const { medias: e, minimumSpends: t, maximumSpends: s } = this.getSpendLimitsFromContext();
    return e.map((i) => ({
      medium: i,
      lowerLimit: t[i],
      upperLimit: s[i]
    }));
  }
  async getActiveDaysPerMedium() {
    await this.ensureInitialized(), await c();
    const e = this.dataSourceReaderService, [t] = e.getSpendPeriods();
    return t;
  }
  async updateRules(e) {
    await c();
    try {
      const t = e.map((i) => ({
        channel: i.channel,
        type: i.type,
        subtype: i.subtype,
        value: i.value
      })), s = this.pyodide.toPy(t);
      this.pyOptimiser.rules.update_rules(s), s.destroy();
    } catch (t) {
      throw new Error(`Failed to update rules: ${t.message}`);
    }
    await c();
  }
  async getKPILimits(e, t, s) {
    if (e && t && t > 0) {
      const n = this.getPyodideUtil("get_kpi_bounds_for_period")(this.pyOptimiser, this.toPyDate(e), t, s !== !1).toJs();
      return [n[0], n[1]];
    }
    const i = this.pyOptimiser.get_kpi_bounds().toJs();
    return [i[0], i[1]];
  }
  async getBudgetLimits(e, t) {
    if (e && t && t > 0) {
      const a = this.getPyodideUtil("get_budget_bounds_for_period")(this.pyOptimiser, this.toPyDate(e), t).toJs();
      return [a[0], a[1]];
    }
    const s = this.pyOptimiser.get_budget_bounds().toJs();
    return [s[0], s[1]];
  }
  async getTotalKPILimits(e, t, s) {
    if (e && t && t > 0) {
      const n = this.getPyodideUtil("get_total_kpi_bounds_for_period")(this.pyOptimiser, this.toPyDate(e), t, s !== !1).toJs();
      return [n[0], n[1]];
    }
    const i = this.pyOptimiser.get_total_kpi_bounds().toJs();
    return [i[0], i[1]];
  }
  async getNonMediaKpi() {
    return this.getPyodideUtil("get_non_media_kpi")(this.pyOptimiser);
  }
  async getChannelPeriodFractions(e, t) {
    if (!e || !t || t <= 0)
      return {};
    const i = this.getPyodideUtil("get_channel_period_fractions")(this.pyOptimiser, this.toPyDate(e), t), a = i.toJs({ dict_converter: Object.fromEntries });
    return i.destroy?.(), a;
  }
  async setAllowedWeekdays(e, t) {
    if (t.length !== 7)
      throw new Error("weekdayFlags must be an array of exactly 7 boolean values (Monday-Sunday)");
    await c();
    try {
      const i = this.pyOptimiser.daily_plan_manager.allowed_weekdays, a = this.pyodide.toPy(t);
      i.set(e, a), a.destroy(), this.pyOptimiser.latest_daily_plan = null;
    } catch (s) {
      throw new Error(`Failed to set allowed weekdays for ${e}: ${s.message}`);
    }
    await c();
  }
  async clearDailyPlanCache() {
    await c();
    try {
      this.pyOptimiser.latest_daily_plan = null;
      const e = this.pyOptimiser.daily_plan_manager.cache_manager;
      e && typeof e.clear == "function" && e.clear();
    } catch (e) {
      console.warn("Failed to clear daily plan cache:", e.message);
    }
    await c();
  }
  async getAllowedWeekdays(e) {
    try {
      const i = this.pyOptimiser.daily_plan_manager.allowed_weekdays.get(e);
      return i !== void 0 ? i.toJs ? i.toJs() : Array.from(i) : [!0, !0, !0, !0, !0, !0, !0];
    } catch (t) {
      throw new Error(`Failed to get allowed weekdays for ${e}: ${t.message}`);
    }
  }
  async getAllAllowedWeekdays() {
    try {
      const s = this.pyOptimiser.daily_plan_manager.allowed_weekdays.toJs(), i = {};
      for (const [a, n] of Object.entries(s))
        Array.isArray(n) ? i[a] = n : n && typeof n == "object" ? i[a] = Object.values(n) : i[a] = [!0, !0, !0, !0, !0, !0, !0];
      return i;
    } catch (e) {
      throw new Error(`Failed to get all allowed weekdays: ${e.message}`);
    }
  }
  async validateTarget(e, t) {
    let s, i;
    t === "totalKpi" ? [s, i] = await this.getTotalKPILimits() : t === "mediaKpi" ? [s, i] = await this.getKPILimits() : [s, i] = await this.getBudgetLimits();
    const a = t === "totalKpi" ? "Total KPI" : t === "mediaKpi" ? "Media KPI" : "Budget";
    return e < s ? {
      valid: !1,
      min: s,
      max: i,
      message: `Target ${a} (${e.toLocaleString()}) is below minimum achievable (${s.toLocaleString()}). The minimum spending constraints produce more ${a} than your target. Either increase your target or reduce the lower spending limits.`
    } : e > i ? {
      valid: !1,
      min: s,
      max: i,
      message: `Target ${a} (${e.toLocaleString()}) exceeds maximum achievable (${i.toLocaleString()}). Either decrease your target or increase the upper spending limits.`
    } : { valid: !0, min: s, max: i };
  }
  async optimise(e, t = "budget") {
    let s;
    if (t === "totalKpi")
      s = this.pyOptimiser.optimise_total_kpi(e);
    else {
      const d = t === "mediaKpi";
      s = this.pyOptimiser.optimise(e, d);
    }
    await c();
    const { medias: i, minimumSpends: a, maximumSpends: n } = this.getSpendLimitsFromContext();
    await c();
    let l;
    try {
      l = this.getPyodideUtil("recalculate_kpis")(this.pyOptimiser, s.toJs()).toJs();
    } catch {
      try {
        const w = this.pyOptimiser.recalculate_kpis(s);
        l = p(w, (_) => _.values.toJs());
      } catch {
        l = new Array(i.length).fill(0);
      }
    }
    const m = this.normalizeKpisArray(l, i);
    await c();
    const h = this.pyOptimiser.total_kpi(s), y = await this.getNonMediaKpi();
    return this.buildOptimal(
      s,
      i,
      a,
      n,
      m,
      h,
      y,
      e,
      t
    );
  }
  refineSpend(e) {
    return Math.round(e);
  }
  async createOptimisedPlans(e, t, s, i = "budget", a) {
    if (!t) {
      const O = JSON.parse(this.recentYearSpends)["Period name"], N = Math.min(...Object.keys(O).map(Number)), B = Math.max(...Object.keys(O).map(Number));
      t = new Date(O[N] * 1e3), s = new Date(O[B] * 1e3);
    }
    if (t > s)
      throw new Error("Start date for optimized plan does not situate before the end date");
    await c();
    const n = ue(s, t);
    if (n > x.MAX_DAYS_IN_YEAR)
      throw new Error(`Period (${n} days) is too long ( >${x.MAX_DAYS_IN_YEAR} ).`);
    await c();
    const l = this.getPyodideUtil("create_optimised_plans_for_period"), m = i === "mediaKpi", h = i === "totalKpi", y = a !== !1;
    let [d, w, _] = await p(
      await l(
        this.pyOptimiser,
        this.toPyDate(t),
        this.toPyDate(s),
        e,
        m,
        h,
        y
      ),
      async (o) => Promise.all([
        K(this.pyodide, o.at(0)),
        K(this.pyodide, o.at(1)),
        K(this.pyodide, o.at(2))
      ])
    );
    const f = this.pyOptimiser.optimal_spends, { medias: g, minimumSpends: k, maximumSpends: C } = this.getSpendLimitsFromContext(), v = n + 1;
    let S;
    try {
      S = this.getPyodideUtil("recalculate_kpis_for_period")(this.pyOptimiser, f, v, y).toJs();
    } catch {
      try {
        S = this.getPyodideUtil("recalculate_kpis")(this.pyOptimiser, f.toJs()).toJs();
      } catch {
        S = new Array(g.length).fill(0);
      }
    }
    const T = this.normalizeKpisArray(S, g);
    await c();
    let D;
    try {
      D = this.getPyodideUtil("total_kpi_for_period")(this.pyOptimiser, f, v, y);
    } catch {
      D = this.pyOptimiser.total_kpi(f);
    }
    const R = await this.getNonMediaKpi(), W = this.buildOptimal(
      f,
      g,
      k,
      C,
      T,
      D,
      R,
      e,
      i
    );
    await c();
    const L = z(V(G(d, this.medias), this.medias)), E = ie(new Float64Array(this.medias.map((o) => L[o] || 0))), U = X(d, "Period name").map((o) => new Date(o));
    d = q(d, U, [
      ["Year", (o) => o.getFullYear()],
      ["Month", (o) => o.getMonth() + 1],
      ["ISO Month", (o) => Y(o, 4).getMonth() + 1],
      ["ISO Week of Year", M],
      [
        "ISO Week of Month",
        (o) => {
          const O = M(A(pe(Y(o, 4)), 3));
          return M(o) - O + 1;
        }
      ],
      ["ISO Weekday", j]
    ]), await c();
    const $ = this.calculatePlanFor("ISO Weekday", d);
    return await c(), {
      optimal: W,
      refinedSpends: E,
      optimizedPlan: d,
      monthly: _,
      weekly: w,
      daily: $
    };
  }
  calculatePlanFor(e, t) {
    const s = Q(t, e, this.medias), i = {};
    return i[e] = s.map((a) => a[e]), this.medias.forEach((a) => {
      i[a] = s.map((n) => n[a] || 0);
    }), re(i);
  }
  toPyDate(e) {
    return this.getToPyDate()(e);
  }
  /**
   * Returns the version of the optimizer Python package (core_optimizer).
   */
  getOptimizerVersion() {
    return this.pyodide.runPython(`
      from importlib.metadata import version
      def get_version():
        return version('core_optimizer')
      get_version
    `)();
  }
  async close() {
    super.close(), await this.dataSourceReaderService.close();
  }
}
export {
  me as OptimizationMode,
  Pe as OptimizerService
};
